// Personal libs
import { Repository } from './common/repository.class';
import {
  IApiGetTokensParams,
  apiPostAuth,
  apiPostRefreshTokens,
  apiPostForgottenPass,
} from '@data/datasource/remote/auth.api';
import { ApiError } from '@shared/error/api.error';
import { IApiResponse } from '@shared/interface/api-response.interface';
import { $t } from '@i18n/utils';
import { timestampToLitteral } from '@shared/lib/date.lib';
import { ApiErrorLabel } from '@shared/enum/api-error-label.enum';
import { IAuthRequest } from '@shared/interface/auth-request.interface';
import { IAuthResponse } from '@shared/interface/auth-response.interface';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

class AuthRepository extends Repository {
  constructor() {
    super();
  }

  /*****************************************
   *
   * POST FUNCTIONS
   *
   *****************************************/
  // Refresh tokens
  refreshTokens(
    params: IApiGetTokensParams,
  ): Promise<IApiResponse<IAuthResponse, string> | undefined> {
    return apiPostRefreshTokens(params)
    // return apiPostRefreshTokens(params).catch((error: ErrorConstructor) => {
    //   if (error instanceof ApiError) {
    //     if (error.code != null && error.code !== 'REFRESH_OK') {
    //       throw new Error('erreur lors du renouvellement du token');
    //     } else {
    //       throw new Error('Erreur inconnue');
    //     }
    //   } else if (error.toString().includes(ApiErrorLabel.NetworkError)) {
    //     throw new Error(ApiErrorLabel.NetworkError);
    //   } else {
    //     throw new Error('Erreur inconnue');
    //   }
    // });
  }

  forgottenPass(
    email: string,
  ): Promise<void | IApiResponse<string, undefined>> {
    return apiPostForgottenPass({ email }).catch((error: ErrorConstructor) => {
      if (error instanceof ApiError) {
        if (error.code === 'FORGOT_ERR_01') {
          throw new Error(
            $t('forgottenPass.msg.error01', {
              rateLimitRemaining: error.rateLimit?.remaining,
              rateLimitReset: timestampToLitteral(error.rateLimit?.reset),
            }),
          );
        } else if (error.code === 'FORGOT_ERR_02') {
          throw new Error(
            $t('forgottenPass.msg.error02', {
              rateLimitRemaining: error.rateLimit?.remaining,
              rateLimitReset: timestampToLitteral(error.rateLimit?.reset),
            }),
          );
        } else if (error.code === 'FORGOT_ERR_03_INACTIVE') {
          throw new Error(
            $t('forgottenPass.msg.error03Inactive', {
              rateLimitRemaining: error.rateLimit?.remaining,
              rateLimitReset: timestampToLitteral(error.rateLimit?.reset),
            }),
          );
        } else if (error.code === 'FORGOT_ERR_03_VALIDATING') {
          throw new Error(
            $t('forgottenPass.msg.error03Validating', {
              rateLimitRemaining: error.rateLimit?.remaining,
              rateLimitReset: timestampToLitteral(error.rateLimit?.reset),
            }),
          );
        } else if (error.code === 'FORGOT_ERR_03_REFUSED') {
          throw new Error(
            $t('forgottenPass.msg.error03Refused', {
              rateLimitRemaining: error.rateLimit?.remaining,
              rateLimitReset: timestampToLitteral(error.rateLimit?.reset),
            }),
          );
        } else if (error.code === 'FORGOT_ERR_04') {
          throw new Error($t('forgottenPass.msg.error04'));
        } else if (error.code === 'FORGOT_ERR_05') {
          throw new Error($t('forgottenPass.msg.error05'));
        } else if (error.code === 'FORGOT_ERR_RATE_LIMIT') {
          throw new Error(
            $t('forgottenPass.msg.error_rate_limit', {
              rateLimitReset: timestampToLitteral(error.rateLimit?.reset),
            }),
          );
        }
      } else {
        throw this.manageUnknownError(sessionManager.isOnline.value)
      }
    });
  }

  // Refresh tokens
  auth(
    params: IAuthRequest,
  ): Promise<IApiResponse<IAuthResponse, string> | undefined> {
    return apiPostAuth(params).catch((error: ErrorConstructor) => {
      if (error instanceof ApiError) {
        if (error.code?.startsWith('AUTH_ERR')) {
          throw new Error(
            $t(`signin.login.error.${error.code}`, {
              rateLimitRemaining: error.rateLimit?.remaining,
              rateLimitReset: timestampToLitteral(error.rateLimit?.reset),
            }),
          );
        } else {
          throw new Error($t('generic.unknownError'));
        }
      } else {
        throw this.manageUnknownError(sessionManager.isOnline.value)
      }
    });
  }
}

export default new AuthRepository();
